import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';

import {
  getAMLSCommonPipelines,
  postAMLSCommonPipelinesRun,
  postAMLSCommonPipelinesSchedule,
  postAMLSCommonPipelinesUnSchedule,
  getAMLSCommonPipelinesScheduleInfo,
  getAMLSCommonPipelinesHistory,
  postAMLSCommonPipelineStop
} from '../../../redux/actions/common';
import Pipelines from './Pipelines';

const mapStateToProps = (state) => ({
  pipelines: get(state, 'amlsCommon.pipelines.data', []) || [],
  pipelinesLoading: get(state, 'amlsCommon.pipelines.isLoading', false),
  pipelinesScheduleData: get(state, 'amlsCommon.pipelinesSchedule.data'),
  pipelinesUnScheduleData: get(state, 'amlsCommon.pipelinesUnSchedule.data'),
  pipelinesScheduleInfo: get(state, 'amlsCommon.pipelinesScheduleInfo.data'),
  pipelinesScheduleInfoLoading: get(
    state,
    'amlsCommon.pipelinesScheduleInfo.isLoading',
    false
  ),
  pipelinesHistory: get(state, 'amlsCommon.pipelinesHistory.data'),
  pipelinesHistoryIsLoading: get(
    state,
    'amlsCommon.pipelinesHistory.isLoading'
  ),
  pipelineStop: get(state, 'amlsCommon.pipelineStop')
});

const mapDispatchToProps = (dispatch) => {
  return {
    apiActions: bindActionCreators(
      {
        getAMLSCommonPipelines,
        postAMLSCommonPipelinesRun,
        postAMLSCommonPipelinesSchedule,
        postAMLSCommonPipelinesUnSchedule,
        getAMLSCommonPipelinesScheduleInfo,
        getAMLSCommonPipelinesHistory,
        postAMLSCommonPipelineStop
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pipelines);
